module.exports = __webpack_public_path__ + "img/image-polaroid.df17b8aa.svg";